import React, { useContext, useState } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Form, Button, Container, Card, Alert, Spinner } from "react-bootstrap";
import { API_COLORS } from "../constants/colors";
import "../css/auth.css";
import { baseURL } from "../services/api";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { login } = useContext(AuthContext);
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    
    try {
      const res = await axios.post(`${baseURL}api/login`, {
        email: credentials.email,
        password: credentials.password,
      });

      login(res.data.user, res.data.token);

      if (res.data.user.role === "admin") {
        navigate("/");
      } 
      else if (res.data.user.role === "superadmin") {
        navigate("/");
      }
      
      else {
        navigate("/leaves");
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="auth-container">
      <Container fluid>
        <Card className="auth-card">
          <Card.Body className="auth-card-body">
            <h2 className="auth-title">Welcome Back</h2>
            
            {error && (
              <Alert variant="danger" className="mt-3">
                {error}
              </Alert>
            )}

            <Form onSubmit={handleLogin} className="auth-form">
              <Form.Group controlId="formEmail" className="auth-form-group">
                <Form.Label className="auth-label">Email address</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={credentials.email}
                  onChange={handleChange}
                  required
                  className="auth-input"
                  placeholder="Enter your email"
                  isInvalid={error && error.includes('email')}
                />
                <Form.Control.Feedback type="invalid">
                  {error && error.includes('email') ? error : ''}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="formPassword" className="auth-form-group">
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Label className="auth-label">Password</Form.Label>
                  <Button 
                    variant="link" 
                    className="auth-link p-0" 
                    onClick={() => navigate('/forgot-password')}
                  >
                    Forgot Password?
                  </Button>
                </div>
                <Form.Control
                  type="password"
                  name="password"
                  value={credentials.password}
                  onChange={handleChange}
                  required
                  className="auth-input"
                  placeholder="Enter your password"
                  isInvalid={error && error.includes('password')}
                />
                <Form.Control.Feedback type="invalid">
                  {error && error.includes('password') ? error : ''}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="d-grid gap-3 mt-4">
                <Button
                  variant="primary"
                  type="submit"
                  disabled={loading}
                  className="auth-button"
                  style={{ backgroundColor: API_COLORS.PRIMARY }}
                >
                  {loading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                  ) : null}
                  {loading ? 'Logging in...' : 'Login'}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default Login;